import { type ParentProps, createResource } from "solid-js";
import { fetchLinks } from "../../repositories/links";
import { LinksContext } from "./context";

interface LinksProviderProps {
	id: string;
}

export function LinksProvider(props: ParentProps<LinksProviderProps>) {
	const [list] = createResource(() => props.id, fetchLinks);

	return <LinksContext.Provider value={{ list: list }}>{props.children}</LinksContext.Provider>;
}
